<template>
  <div class="viewer" ref="preview">
    <div class="viewer-toolbar">
      <div class="pull-right tool">
        <a
          @click="close"
          data-toggle="tooltip"
          data-placement="bottom"
          title="关闭"
        >
          <i class="iconfont icon-close"></i>
        </a>
      </div>

      <div class="dropdown pull-right" v-if="showChageSize">
        <a data-toggle="dropdown" aria-haspopup="true" aria-expanded="true">
          <i class="iconfont icon-more"></i>
        </a>
        <ul
          class="dropdown-menu dropdown-menu-right"
          aria-labelledby="dropdownMenu1"
        >
          <li>
            <a @click="originalSize"> <i class="ti-image"></i>原始尺寸 </a>
          </li>
          <li>
            <a @click="initWidthHeight">
              <i class="ti-layout-slider-alt"></i>自适应尺寸
            </a>
          </li>
        </ul>
      </div>

      <div class="cont">
        <div class="name">
          <h4>
            {{ fileInfo | formatData }}
            <span
              class="cursor"
              v-if="version"
              :title="'当前预览的文档版本号为：' + version"
              >[{{ version }}]</span
            >
          </h4>
        </div>
      </div>
    </div>
    <div class="viewer-body">
      <div class="carousel-inner">
        <component :is="previewer"></component>
      </div>
    </div>
  </div>
</template>

<script>
import { formatData } from "@/utils/index";
import Bus from "@/utils/bus";
import { getPreviewTypeByFileExt } from "@/utils/icon";
import {
  preview,
  fileOrFolderInfo,
  previewFileVersion,
} from "@/api/drive/drive";
export default {
  name: "Preview",
  data() {
    return {
      showChageSize: false,
      previewer: "unknowPreview",
      number: "",
      version: null,
      group_number: "",
      type: "file",
      fileInfo: {},
      preview_path: "",
    };
  },
  created() {
    this.$store.commit("SET_THEME", "预览");
    let number = this.$route.params.number;
    if (!number) {
      this.$message({
        type: "error",
        message: "参数错误",
      });
      return false;
    }
    this.group_number = this.$route.params.group_number
      ? this.$route.params.group_number
      : null;
    this.number = number;
    this.$store.commit("setPreviewData", {
      file_ext: "",
      position: "fullscreen-top",
      preview_path: "",
      previewer: "unknowPreview",
      message: "正在加载...",
    });
    this.fileOrFolderInfo();
  },
  filters: {
    formatData,
  },
  methods: {
    close() {
      window.close();
    },
    // 获取文件详情
    fileOrFolderInfo() {
      fileOrFolderInfo({
        number: this.number,
        type: "file",
        is_path: true,
        group_number: this.group_number,
      })
        .then((res) => {
          if (res.status_code === 200) {
            if (res.entity.is_lock) {
              this.$message({
                type: "warning",
                message: `该文件已被锁定，锁定原因：${res.entity.lock_reason}。如需解锁，请联系管理员`,
              });
              return false;
            }
            this.fileInfo = res.entity;
            this.version = this.$route.params.version;
            if (this.version) {
              this.previewHistory();
            } else {
              this.preview();
            }
          } else {
            this.$message({
              type: "error",
              message: res.message,
            });
          }
        })
        .catch((err) => {
          this.$message({
            type: "error",
            message: err,
          });
        });
    },
    // 获取资源链接地址（历史版本）
    previewHistory() {
      previewFileVersion({
        version: this.version,
        file_id: this.number,
        group_number: this.group_number,
      })
        .then((res) => {
          if (res.status_code === 200) {
            let previewer =
              getPreviewTypeByFileExt(this.fileInfo.file_ext) + "Preview";
            let preview_path = res.entity.preview_path;
            if (
              res.entity.category === "video" &&
              res.entity.trans_path &&
              !res.entity.is_preview
            ) {
              preview_path = res.entity.trans_path;
              previewer = "mp4Preview";
            }
            if (previewer === "imgPreview") {
              this.showChageSize = true;
            }
            this.$store.commit("setPreviewData", {
              file_ext: this.fileInfo.file_ext,
              position: "fullscreen-top",
              preview_path: preview_path,
              previewer: previewer,
            });
            this.previewer = previewer;
          } else {
            this.$store.commit("setPreviewData", {
              file_ext: "",
              position: "fullscreen-top",
              preview_path: "",
              previewer: "unknowPreview",
              message: res.message,
            });
          }
        })
        .catch((err) => {
          this.$message({
            type: "error",
            message: err,
          });
        });
    },
    // 获取资源链接地址
    preview() {
      preview({
        number: this.number,
        group_number: this.group_number,
      })
        .then((res) => {
          if (res.status_code === 200) {
            let previewer =
              getPreviewTypeByFileExt(this.fileInfo.file_ext) + "Preview";
            let preview_path = res.entity.preview_path;
            if (
              res.entity.category === "video" &&
              res.entity.trans_path &&
              !res.entity.is_preview
            ) {
              preview_path = res.entity.trans_path;
              previewer = "mp4Preview";
            }
            if (previewer === "imgPreview") {
              this.showChageSize = true;
            }
            this.$store.commit("setPreviewData", {
              file_ext: this.fileInfo.file_ext,
              position: "fullscreen-top",
              preview_path: preview_path,
              previewer: previewer,
            });
            this.previewer = previewer;
          } else {
            this.$store.commit("setPreviewData", {
              file_ext: "",
              position: "fullscreen-top",
              preview_path: "",
              previewer: "unknowPreview",
              message: res.message,
            });
          }
        })
        .catch((err) => {
          this.$message({
            type: "error",
            message: err,
          });
        });
    },
    resizePreview() {
      this.$refs.preview.style.height = window.innerHeight + "px";
    },
    // 设置为自适应尺寸
    initWidthHeight() {
      Bus.$emit("initWidthHeight");
    },
    // 设置为原始尺寸
    originalSize() {
      Bus.$emit("originalSize");
    },
  },
  mounted() {
    $(function () {
      $('[data-toggle="tooltip"]').tooltip();
    });
    this.$refs.preview.style.height = window.innerHeight + "px";
    window.addEventListener("resize", this.resizePreview);
  },
  destroyed() {
    window.removeEventListener("resize", this.resizePreview);
  },
};
</script>

<style scoped>
.cursor {
  cursor: default;
}
</style>